/* ••[1]••••••••••••••••••••••••• Spotlight.ts •••••••••••••••••••••••••••••• */

type Spotlight = {
  authorImage: string;
  authorName: string;
  authorOrganizationPosition: string;
  spotlightContent: string;
  spotlightTitle: string;
};

function validatedSpotlight(spotlight: Spotlight): Spotlight | null {
  if (
    "authorImage" in spotlight &&
    typeof spotlight.authorImage === "string" &&
    "authorName" in spotlight &&
    typeof spotlight.authorName === "string" &&
    "authorOrganizationPosition" in spotlight &&
    typeof spotlight.authorOrganizationPosition === "string" &&
    "spotlightContent" in spotlight &&
    typeof spotlight.spotlightContent === "string" &&
    "spotlightTitle" in spotlight &&
    typeof spotlight.spotlightTitle === "string"
  ) {
    return spotlight;
  }

  return null;
}

export { Spotlight, validatedSpotlight };
